<template>
  <div class="chat-box" :style="{height: boxHeight + ' !important'}">
    <ChatDialogScout
      :updateSkFlg="updateSkFlg"
      :widgetData="widgetData"
      @scoutEmailParam="scoutEmailParam"
      @setOpenForm="setOpenForm"
      v-if="isOpenForm&&widgetData.scout_flg"
    />
    <div style="width: 100%; height: 100%; padding: 16px; position: absolute; background: #f8f8f8ee; z-index: 999;" v-if="!isOnLine || ws==null">
      現在接続がされておりません。<br>
      すぐに再接続しますか？<br>
      （自動でも再接続されます）<br><br>
      <a class="button is-primary" @click="reconnect()">再接続する</a>
    </div>
    <div style="width: 100%; height: 100%; padding: 16px; position: absolute; background: #f8f8f8ee; z-index: 999;" v-else-if="!chatbot.is_confirm">
      現在メンテナンス中です。
    </div>
    <div style="width: 100%; height: 100%; padding: 16px; position: absolute; background: #f8f8f8ee; z-index: 999;" v-else-if="this.lastView">
      以前にこのロボとやりとりしたことがあります。<br>
      続きから再開しますか？<br><br>
      <a class="button is-small" @click="scenarioStart('top')">最初から始める</a>
      <a class="button is-small" @click="scenarioStart('continue')">続きから始める</a>
    </div>
    <ChatDialogHeader
      :color="color"
      :isOpenForm="isOpenForm"
      :widgetData="widgetData"
      :headerType="headerType"
      :headerTitle="headerTitle"
      @setOpenForm="setOpenForm"
      @subscribe="subscribe"
      @sendContact="sendContact"
      v-if="color.headerType != 0 || (widgetData.scout_flg && seeker.count >= 3 && !widgetData.scout_mail_flg) || headerType > 0"
    />
    <div class="chat-box-timeline" :style="getHeight()">
      <div class="chat-list-box" @click="nextScenario()">
        <div class="mdi mdi-loading mdi-spin mdi-24px" v-if="isNoScroll"></div>
        <div style="position: fixed; z-index: 100; width: calc(100% - 10px); height: calc(100% - 72px); border-bottom-right-radius: 10px; border-bottom-left-radius: 10px; background: white; top: 72px;" v-if="isLoadChatlog">
          <Loading/>
        </div>
        <div class="bln-lst">
          <transition-group name="bln" tag="div">
          <Balloon
            ref="bln"
            v-for="(chat, index) in messageHistory.concat(chatLogs)" :key="index"
            :id="'scrollto-' + index"
            :speaker="chat.speaker"
            :name="chat.name"
            :icon="chat.icon"
            :message="chat.message"
            :time="new Date(chat.createdAt)"
            :readTime="new Date(widgetData.readTime)"
            :isBot="chat.isBot"
            :email="chat.email"
            :isManager="chat.isManager"
            :logIndex="index"
            :lastIndex="messageHistory.concat(chatLogs).length - 1"
            :files="chat.files"
            :filename="chat.filename"
            :status="chat.status"
            :parameter="chat.parameter"
            :companyData="widgetData"
            :isPast="isPast(index)"
            :roboPartsSetOutsideScenario="roboPartsSetOutsideScenario"
            :roboPartsSetNextNode="roboPartsSetNextNode"
            @setLocalStorage="setLocalStorage"/>
          </transition-group>
          <MogoMogo v-if="isTyping||isSCNLoading||messageLoading"/>
          <div style="height: 42px; width: 200px;" v-else></div>
          <div style="height: 104px;"></div>
        </div>
        <div class="tap-box" v-if="tapNaviCheck()">
          <div class="tap" v-if="!talkEnd">
            <div class="huyuu">
              <span class="mdi mdi-gesture-double-tap mdi-36px"></span>
            </div>
            <p>タップ/クリックをすることで次へ進みます。</p>
          </div>
          <div v-else>
            <div v-if="isQuestionnaire">
              <ModalChatBotQuestionnaire
                :isShowModal = "isShowModal"
                :bot_id = "chatbot.bot_id"
                :seeker_id = "seeker.id"
                :company_id = "this.data.ckey"
                @cancel="cancelModal"/>
            </div>
          </div>
        </div>
        <div class="tap-box" v-else-if="talkEnd && isQuestionnaire">
          <ModalChatBotQuestionnaire
            :isShowModal = "isShowModal"
            :bot_id = "chatbot.bot_id"
            :seeker_id = "seeker.id"
            :company_id = "this.data.ckey"
            @cancel="cancelModal"/>
        </div>
      </div>
    </div>
    <!-- 入力フォーム -->
    <div class="parent-form" :class="{'no-input-form': color.inputType==0}">
      <div class="child-form" v-if="color.inputType!=0">
        <b-field>
          <Picker title='絵文字を選択' @select="selectEmoji" style="position: fixed; bottom: 70px; right: 12px;" v-show="isOpenEmoji"/>
          <textarea
            placeholder="こちらに入力"
            v-model="chatData.message"
            @keydown.ctrl.enter="chatData.message=alterReplace(chatData.message, false);submit()"
            @keydown.meta.enter="chatData.message=alterReplace(chatData.message, false);submit()"
            style="border-bottom-left-radius: 10px; background: rgba(255, 255, 255, 0) !important;"
            :style="{height: height + 'px !important'}">
          </textarea>
          <div class="btn-menu">
            <button class="button input-button"
                    @click="isOpenEmoji=!isOpenEmoji">
              <span class="mdi mdi-emoticon" style="color: #333;"></span>
            </button>
            <button class="button input-button"
                    @click="chatData.message=alterReplace(chatData.message, false);submit()">
              <span class="mdi mdi-send" style="color: #333;"></span>
            </button>
          </div>
        </b-field>
      </div>
      <section class="footer-area">
        <div class="left-block"></div>
        <div class="center-block" v-if="data.ckey==='1dad12e572955a7fc7fbb820a0b30a79'">
          <!-- 介護NEXT様用 -->
          <p style="font-size: 12.5px; color: #999;">Powered by <a href="https://hr-monster.io" target="_blank" rel="noopener" style="text-decoration: underline;">HRモンスター</a>/原稿copyright Kaigonext 2021</p>
        </div>
        <div class="center-block" v-else>
          <p style="font-size: 12.5px; color: #999;">Powered by <a href="https://hr-monster.io" target="_blank" rel="noopener" style="text-decoration: underline;">HRモンスター</a></p>
        </div>
        <div class="right-block">
          <button class="button is-small is-primary auto-button" @click="backScenario()" :disabled="isInputBack">
            <span class="mdi mdi-undo" style="margin-right: 8px;"></span>戻る
          </button>
          <button class="button is-small is-primary auto-button" @click="$clickAutoBtn(false)" v-if="isAutomatic">
            <span class="mdi mdi-spin mdi-autorenew" style="margin-right: 8px;"></span>自動
          </button>
          <button class="button is-small auto-button" @click="$clickAutoBtn(true)" v-if="!isAutomatic">
            <span class="mdi mdi-autorenew" style="margin-right: 8px;"></span>自動
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapState }      from 'vuex'
import Balloon           from '@/components/ui/Balloon'
import Loading           from '@/components/animations/Loading'
import { Emoji, Picker } from 'emoji-mart-vue'
import MogoMogo          from '@/components/ui/MogoMogo'
import alterReplace      from '@/functions/alterStrReplace'
import ChatDialogScout   from '@/components/ChatWidgetDialog/organisms/ChatDialogScout'
import ChatDialogHeader  from '@/components/ChatWidgetDialog/organisms/ChatDialogHeader'
import resetLocalStorageSeeker from '@/functions/resetLocalStorageSeeker'
import connectCheckMixin from '@/mixins/connectCheckMixin'
import ModalChatBotQuestionnaire from '@/components/ChatBot/organisms/ModalChatBotQuestionnaire'

export default {
  name: 'ChatDialog',
  components: {
    Emoji,
    Picker,
    Balloon,
    Loading,
    MogoMogo,
    alterReplace,
    ChatDialogScout,
    ChatDialogHeader,
    ModalChatBotQuestionnaire
  },
  props: {
    headerType: {
      type: Number
    },
    headerTitle: {
      type: String
    },
  },
  mixins: [
    connectCheckMixin,
  ],
  computed: {
    ...mapState('directtalk', ['own', 'chatLogs', 'messageHistory', 'data', 'seeker', 'chatData', 'typing', 'mobileKey', 'widgetData', 'color', 'ws', 'chatLogsLoading', 'target', 'targetIcon', 'targetID', 'targetModel', 'messagePages', 'messageLoading','updateSkFlg', 'seekerContactDone', 'chatTalkHistory']),
    ...mapState('chatbot', ['isSCNLoading', 'scenario', 'isAutomatic', 'talkEnd', 'minipk', 'lastView', 'roboPartsSetOutsideScenario', 'roboPartsSetNextNode']),
    ...mapState('calendar', ['isRecommendScheduleLoading']),
    boxHeight () {
      return 'calc(100%)'
    },
    isInputBack() {
      let logs = this.chatTalkHistory.filter(obj => {
        return obj.speaker === 'other'
      })
      if (logs.length > 1) {
        // 選択肢、自由入力、チェックボックス、プルダウンパーツ、カルーセル、検索パーツかつ、前のシナリオと同一（間にロボ切り替えがない）場合はdisabledを外す
        return !(
          (logs[logs.length - 2].status === 0 ||
            logs[logs.length - 2].status === 6 ||
            logs[logs.length - 2].status === 13 ||
            logs[logs.length - 2].status === 15 ||
            logs[logs.length - 2].status === 17 ||
            logs[logs.length - 2].status === 20) &&
          logs[logs.length - 2].is_back &&
          logs[logs.length - 2].email === this.targetID &&
          logs[logs.length - 2].scenarioNode != this.scenario.select[0].next_node
        )
      } else {
        return true
      }
    },
  },
  data () {
    return {
      isTyping: false,
      isTypingScroll: false,
      isMobileInput: false,
      height: 50,
      num: null,
      isClose: false,
      isOnce: false,
      isNoScroll: false,
      isOpenEmoji: false,
      isOpenForm: false,
      isLoadChatlog: true,
      sexTypes  : ['', '男性', '女性', '選択しない'],
      isOnceNavi: false,
      chatLen: false,
      chatbot: [],
      isQuestionnaire: false,
      isShowModal: false
    }
  },
  watch: {
    typing () {
      if (this.typing.indexOf('start_typing:') !== -1) {
        this.isTyping = true
        if (!this.isTypingScroll) {
          this.isTypingScroll = true
          this.$nextTick(() => {this.scrollDown()})
        }
      } else if (this.typing.indexOf('end_typing:') !== -1) {
        this.isTyping = false
        this.isTypingScroll = false
      }
    },
    isSCNLoading () {
      if (this.isSCNLoading) {
        this.isTypingScroll = true
        this.$nextTick(() => {this.scrollDown()})
      } else {
        this.isTypingScroll = false
      }
    },
    'chatData.message': function () {
      if (this.chatData.message !== '') {
        this.$store.dispatch('directtalk/isTyping', 'start_typing@seeker')
        this.num = this.chatData.message.match(/\r\n|\n/g)
        if (this.num != null) {
          this.height = 90
        } else {
          this.height = 50
        }
      } else {
        this.$store.dispatch('directtalk/isTyping', 'end_typing@seeker')
        this.num = this.chatData.message.match(/\r\n|\n/g)
        if (this.num != null) {
          this.height = 90
        } else {
          this.height = 50
        }
      }
    },
    chatLogs () {
      this.chatLen = false
      if (this.chatLogs.length !== 0) {
        this.$nextTick(() => {this.scrollDown()})
        this.$store.dispatch('directtalk/setIsRead', 'seeker')
      }
    },
    seekerContactDone () {
      if (this.seekerContactDone) {
        alert('送信しました。')
        this.isOpenForm = false
        this.contact = {
          name: '',
          user_email: '',
          user_tel: '',
          content: ''
        }
        this.$store.dispatch('directtalk/resetSeekerContactDone')
      }
    },
    talkEnd () {
      if (this.talkEnd) {
        this.isShowModal = true
        this.isQuestionnaire = this.chatbot.is_questionnaire
      }
    }
  },
  mounted () {
    console.debug('*** Start *** mounted')
    console.log('MOUNTED ON CHAT DIALOG: ' + this.widgetData.newMsgCount + ', ' + this.widgetData.newMsgCountBot)
    var vm = this
    document.addEventListener('DOMFocusIn', function (event) {
      // キーボードが出現した時
      console.log('***** DOMFOCUSIN Height:')
      vm.$store.dispatch('directtalk/mobileType')
    }, false)
    document.addEventListener('DOMFocusOut', function (event) {
      // キーボードが引っ込んだ時
      console.log('***** DOMFOCUSOUT Height: ')
      vm.$store.dispatch('directtalk/mobileType')
    }, false)
    this.$nextTick(() => {
      console.debug('*** Start *** nextTick (mounted)')
      setTimeout(() => {
        this.isLoadChatlog = false
        this.scrollDown()
      }, 1000)
      console.debug('*** End *** nextTick (mounted)')
    })
    this.mountChatPage()
    if (this.widgetData.bots[0].pk) {
      this.$store.dispatch('chatbot/setMiniPK', this.widgetData.bots[0].pk)
    }
    for (const chatbot of this.widgetData.bots) {
      if (chatbot.bot_id === this.targetID) {
        this.chatbot = chatbot
      }
    }
    console.debug('*** End *** mounted')
  },
  methods: {
    isPast (logIndex) {
      return logIndex < this.messageHistory.length
    },
    backScenario () {
      this.$store.dispatch('chatbot/getScenarioOne', {
        companyid: this.data.ckey,
        scenarioName: this.chatTalkHistory[this.chatTalkHistory.length - 2].scenarioName,
        node: this.chatTalkHistory[this.chatTalkHistory.length - 2].scenarioNode,
        rate: this.color.thinking_rate,
        minipk: this.minipk
      })
    },
    tapNaviCheck () {
      if (this.chatLogs.length === 0) return false
      if ( this.chatLogs[this.chatLogs.length-1].status == 2 ||this.chatLogs[this.chatLogs.length-1].status == 5||
           this.chatLogs[this.chatLogs.length-1].status == 14||this.chatLogs[this.chatLogs.length-1].status == 19) {
             return true
      } else {
        return false
      }
    },
    getHeight () {
      let h = 44
      if (this.color.headerType!=0 || (this.widgetData.scout_flg && this.seeker.count >= 3 && !this.widgetData.scout_mail_flg)) h += 55
      if (this.color.inputType!=0) h += 35
      return {'height': 'calc(100% - ' + h + 'px)'}
    },
    reconnect () {
      if (this.ws == null) {
        // 再接続
        var uri = process.env.WS_ENDPOINT + this.data.ckey + '/' + this.seeker.id + '/'
        this.$store.dispatch('directtalk/connect', {uri: uri, category: 'widget'})
      }
    },
    scenarioStart (position) {
      let findBot = null
      for (const chatbot of this.widgetData.bots) {
        if (chatbot.bot_id === this.targetID) {
          findBot = chatbot
        }
      }
      if (position == 'top') {
        resetLocalStorageSeeker(this.seeker.id)
        this.$store.dispatch('chatbot/getScenarioOne', { companyid: this.data.ckey, scenarioName: findBot.scenario_name, node: 'INITIALIZE', rate: this.color.thinking_rate, minipk: this.minipk})
        localStorage.removeItem('scenariolv_' + (this.minipk || this.targetID))
      } else if (position == 'continue') {
        const setItemName = 'CAL_' + this.targetID
        const setItemNamePre = 'PRECAL_' + this.targetID
        const scheduleData = localStorage.getItem(setItemName)
        if (scheduleData) {
          let parseData = JSON.parse(scheduleData)
          parseData.flg = true
          localStorage.setItem(setItemName, JSON.stringify(parseData))
          const preData = localStorage.getItem(setItemNamePre)
          if (preData) {
            alert(preData)
            this.$store.dispatch('calendar/setSuggestedSchedules', JSON.parse(preData))
          }
        }
        this.$store.dispatch('directtalk/restoreTalkHistory', (this.minipk || this.targetID))
        if (this.lastView.isPartsSet) {
          this.$store.dispatch('chatbot/setRoboPartsSetInside', {name: findBot.scenario_name, node: this.lastView.partsSetOutsideNextNode})
        }
        this.$store.dispatch('chatbot/getScenarioOne', {
          companyid: this.data.ckey,
          scenarioName: this.lastView.isPartsSet ? 'parts-set' : findBot.scenario_name,
          node: this.lastView.node,
          rate: this.color.thinking_rate,
          minipk: this.minipk})
      }
      this.$store.commit('chatbot/SET_LAST_VIEW', null)
    },
    isVideo () {
      var flg = localStorage.getItem('IS_VIDEO_FLG')
      return flg
    },
    selectEmoji (emoji) {
      console.debug('*** Start *** selectEmoji')
      console.debug('emoji: ' + JSON.stringify(emoji))
      this.chatData.message += emoji.native
      this.isOpenEmoji = false
      console.debug('*** End *** selectEmoji')
    },
    nextScenario () {
      if ((!this.chatLen && !this.messageLoading && !this.isSCNLoading) && (this.chatLogs[this.chatLogs.length-1].status == 2 || this.chatLogs[this.chatLogs.length-1].status == 5 || this.chatLogs[this.chatLogs.length-1].status == 14 || this.chatLogs[this.chatLogs.length-1].status == 19) ) {
        this.isOnceNavi = true
        this.chatLen = true
        let scenarioName = null
        let nextNode = null
        if (this.scenario.output_flg === true) {
          scenarioName = this.roboPartsSetOutsideScenario
          nextNode = this.roboPartsSetNextNode
        } else {
          scenarioName = this.scenario.name
          nextNode = this.scenario.select[0].next_node
        }
        this.$store.dispatch('chatbot/getScenarioOne', { companyid: this.data.ckey, scenarioName: scenarioName, node: nextNode, rate: this.color.thinking_rate, minipk: this.minipk})
        localStorage.setItem(
          'scenariolv_' + (this.minipk || this.targetID),
          JSON.stringify({
            node: nextNode,
            date: Date().toString(),
            isPartsSet: scenarioName == 'parts-set',
            partsSetOutsideNextNode: scenarioName == 'parts-set' ? this.roboPartsSetNextNode : ''
          }))
      }
    },
    // ヘッダーからの応募
    subscribe (data) {
      // 保存用
      let temp = {
        name            : data.skName,
        email           : data.skEmail,
        tel             : data.skTel,
        message         : data.skMsg,
        name_phonetic   : data.skNamePhonetic,
        sex             : data.skSex,
        birth           : data.skBirth,
        address         : data.skAddress,
        is_subscribe    : true,
        subscribe_count : 1,
        subscribe_date  : new Date().toISOString(),
        progress_rate   : 0,
        sessionid: this.seeker.id,
        group: this.data.ckey,
      }

      // 求人ページか企業ページか判定する
      let apply_url = ''
      let is_contents = ''
      if (this.data.url.indexOf(process.env.LOC_HOST + '/recruit/') > -1 || this.data.url.indexOf(process.env.LOC_HOST + '/cstm/') > -1) {
        const cid = this.data.url.split('/')
        apply_url = cid[cid.length - 1]
        is_contents = true
      } else {
        apply_url = this.data.url
        is_contents = false
      }
      // メール送信用
      var sendData = {
        name            : data.skName,
        email           : data.skEmail,
        tel             : data.skTel,
        other           : data.skMsg,
        company_id      : this.data.ckey,
        sessionid       : this.seeker.id,
        apply_url       : apply_url,
        is_contents     : is_contents,
        disable_email   : false,
      }
      this.$store.dispatch('directtalk/createSeekerATHistory', {target: this.targetID, action: 'subscribe_bot', url: this.data.url, element: 'button'})
      this.$store.dispatch('directtalk/updateSeekerData', temp)
        .then(() => {
          // 待たずに送ってしまうと更新する前の応募者情報で送ってしまうので、updateSeekerDataを待つ
          this.$store.dispatch('auth/sendSubscribe', sendData)
            .then(() => {
              // Websocketの処理でRoomをSELECTして、APIの処理でRoomをUPDATEしている
              // 後続の処理でWebsocketをsendしてRoomをSELECTしてロックしている間にAPI側でUPDATEをしようとしてデッドロックが発生する
              // なのでsendSubscribeNoDataの処理完了を待つ
              // 待つだけで処理なし
              // デッドロックは同じセッション内でWebsocketの各種send処理と、APIでのSeekerやRoomの更新処理などが被ると発生する
              // 同じSeekerやRoomのレコードを参照したり更新しようとして起こるので、別のユーザーと同時接続で処理が被った場合はDjango側の処理でデッドロックは起きない
              // 他のWebsocketのsend処理でも被ることがあるので、API側にもトランザクションを分ける対策を実施
              // この処理の待ち方が正しいとは限らないので、promiseを使うなどスマートな方法に変えられればば変える
            })
        })
      let subscribeMessage = '【応募内容】\n'
      if (this.widgetData.subscribe_is_name) {
        subscribeMessage += 'お名前：' + data.skName + '\n'
      }
      if (this.widgetData.subscribe_is_name_phonetic) {
        subscribeMessage += 'フリガナ：' + data.skNamePhonetic + '\n'
      }
      if (this.widgetData.subscribe_is_sex) {
        subscribeMessage += '性別：' + this.sexTypes[data.skSex] + '\n'
      }
      if (this.widgetData.subscribe_is_email) {
        subscribeMessage += 'Email：' + data.skEmail + '\n'
      }
      if (this.widgetData.subscribe_is_tel) {
        subscribeMessage += 'TEL：' + data.skTel + '\n'
      }
      if (this.widgetData.subscribe_is_birth) {
        let t = data.skBirth
        if (t === null) {
          subscribeMessage += '生年月日：' + '\n'
        } else {
          subscribeMessage += '生年月日：' + t.getFullYear() + '/' + (t.getMonth() + 1) + '/' + t.getDate() + '\n'
        }
      }
      if (this.widgetData.subscribe_is_address) {
        subscribeMessage += '住所：' + data.skAddress + '\n'
      }
      if (this.widgetData.subscribe_is_message) {
        subscribeMessage += '備考：' + data.skMsg + '\n'
      }
      this.chatData.message = subscribeMessage
      this.isOpenForm = false
      this.submit()
      setTimeout(() => {
        var autoReply = {
          message: '承りました！担当からご連絡させていただきます。\nエントリーありがとうございました！',
          name: this.target,
          url: this.own,
          email: this.targetID,
          speaker: 'other',
          icon: this.targetIcon ? this.targetIcon : require('../../assets/template/robot.png'),
          sendToID: '',
          minibot_pk: this.minipk ? this.minipk : '',
          sendToModel: '',
          scenarioNode: '',
          btnIdx: 0,
          createdAt: new Date().toISOString(),
          isManager: this.targetModel === 'user' ? '1' : '2',
          status: -1,
          parameter: null,
          appname: '',
          platform: '',
          refferer: '',
          useragent: '',
          count: 0
        }
        this.$store.dispatch('directtalk/pushChat', autoReply)
      }, 1500)
    },
    submit () {
      console.debug('*** Start *** submit')
      console.log('submit from widget \n' + this.data)
      var w = this.data
      console.log('FROM URL: \n' + w.appname)
      this.chatData.name = this.widgetData.name
      this.chatData.url = w.url
      console.log('Widget: ' + this.chatData.name)
      if (this.chatData.message !== '') {
        console.info('chatData.message is not blank')
        this.chatData.email = ''
        var today = new Date()
        console.log('now: ' + today.toISOString())
        this.chatData.createdAt = today.toISOString()
        this.chatData.isManager = '0'
        this.chatData.sendToID = this.targetID
        if (this.chatData.sendToID == undefined) this.chatData.sendToID = ''
        this.chatData.minibot_pk = this.minipk ? this.minipk : ''
        this.chatData.sendToModel = this.targetModel
        if (this.chatData.sendToModel == undefined) this.chatData.sendToModel = 'input'
        this.chatData.scenarioNode = ''
        this.chatData.btnIdx = 0
        this.chatData.status = -1
        this.chatData.parameter = null
        var promise = Promise.resolve()
        promise
          .then(this.$store.dispatch('auth/slackPost', {companyID: this.data.ckey, seekerID: this.seeker.id, msg: this.chatData.message}))
          .then(this.$store.dispatch('auth/CWPost', {companyID: this.data.ckey, seekerID: this.seeker.id, msg: this.chatData.message}))
          .then(this.$store.dispatch('directtalk/pushChat', this.chatData))
          .then(this.chatData.message = '')
      }
      console.debug('*** End *** submit')
    },
    scrollDown () {
      console.debug('*** Start *** scrollDown')
      var newMsgCnt = Number(this.widgetData.newMsgCount) + Number(this.widgetData.newMsgCountBot)
      console.log('MOUNTED ON 1 ******** ' + newMsgCnt)
      this.$store.dispatch('directtalk/setIsRead', 'seeker')
      if (this.isNoScroll) {
        console.info('isNoScroll is true')
        if (this.chatLogs.length > 20) {
          console.info('chatLogs.length > 20')
          var scrollLine = document.getElementById('scrollto-' + 20)
          scrollLine.scrollIntoView(true)
        }
        this.isNoScroll = false
      } else {
        console.info('isNoScroll is false')
        var scrollLine = document.getElementById('scrollto-' + (this.chatLogs.length + this.messageHistory.length - 1))
        if (scrollLine) {
          scrollLine.scrollIntoView(true)
        }
      }
      this.isOnce = true
      console.debug('*** End *** scrollDown')
    },
    scoutEmailParam (email) {
      var scout_message = this.widgetData.scout_message
      var scout_mail_title = this.widgetData.scout_mail_title
      var scout_mail_message = this.widgetData.scout_mail_message
      const lsPoint = localStorage.getItem('SCR')

      scout_message = scout_message
        .replace(new RegExp('__applicant__', "g"), this.seeker.name          ? this.seeker.name          : '')
        .replace(new RegExp('__email__',     "g"), this.seeker.email         ? this.seeker.email         : '')
        .replace(new RegExp('__tel__',       "g"), this.seeker.tel           ? this.seeker.tel           : '')
        .replace(new RegExp('__address__',   "g"), this.seeker.address       ? this.seeker.address       : '')
        .replace(new RegExp('__furigana__',  "g"), this.seeker.name_phonetic ? this.seeker.name_phonetic : '')
        .replace(new RegExp('__bikou__',     "g"), this.seeker.message       ? this.seeker.message       : '')
        .replace(new RegExp('__point__',     "g"), lsPoint ? lsPoint : '')
      scout_mail_title = scout_mail_title
        .replace(new RegExp('__applicant__', "g"), this.seeker.name          ? this.seeker.name          : '')
        .replace(new RegExp('__email__',     "g"), this.seeker.email         ? this.seeker.email         : '')
        .replace(new RegExp('__tel__',       "g"), this.seeker.tel           ? this.seeker.tel           : '')
        .replace(new RegExp('__address__',   "g"), this.seeker.address       ? this.seeker.address       : '')
        .replace(new RegExp('__furigana__',  "g"), this.seeker.name_phonetic ? this.seeker.name_phonetic : '')
        .replace(new RegExp('__bikou__',     "g"), this.seeker.message       ? this.seeker.message       : '')
        .replace(new RegExp('__point__',     "g"), lsPoint ? lsPoint : '')
      scout_mail_message = scout_mail_message
        .replace(new RegExp('__applicant__', "g"), this.seeker.name          ? this.seeker.name          : '')
        .replace(new RegExp('__email__',     "g"), this.seeker.email         ? this.seeker.email         : '')
        .replace(new RegExp('__tel__',       "g"), this.seeker.tel           ? this.seeker.tel           : '')
        .replace(new RegExp('__address__',   "g"), this.seeker.address       ? this.seeker.address       : '')
        .replace(new RegExp('__furigana__',  "g"), this.seeker.name_phonetic ? this.seeker.name_phonetic : '')
        .replace(new RegExp('__bikou__',     "g"), this.seeker.message       ? this.seeker.message       : '')
        .replace(new RegExp('__point__',     "g"), lsPoint ? lsPoint : '')

      // 置換しきれなかった代替文字列を削除
      scout_message = scout_message
        .replace(new RegExp(/__(\d+|\d+\.[a-z0-9]+|[a-z]+)__/, 'g'), '')
      scout_mail_title = scout_mail_title
        .replace(new RegExp(/__(\d+|\d+\.[a-z0-9]+|[a-z]+)__/, 'g'), '')
      scout_mail_message = scout_mail_message
        .replace(new RegExp(/__(\d+|\d+\.[a-z0-9]+|[a-z]+)__/, 'g'), '')

      const updateData = {
        sessionid         : this.seeker.id,
        email             : email,
        subscribe_count   : 1,
        scout_mail_flg    : true,
        scout_mail_title  : scout_mail_title,
        scout_mail_message: scout_mail_message,
        sessionid: this.seeker.id,
        group: this.data.ckey,
      }
      this.$store.dispatch('directtalk/updateSeekerData', updateData)
    },
    setOpenForm (flg) {
      this.isOpenForm = flg
    },
    mountChatPage () {
      this.$store.dispatch('chatbot/mountChatPage')
    },
    alterReplace (m, d) {
      return alterReplace(m, d)
    },
    sendContact (c) {
      let contact = c
      contact.seeker = this.seeker.pk
      contact.company_name = this.widgetData.companyName
      contact.company_email = this.widgetData.companyEmail
      if (this.sendSeekerContactValidation(c)) return
      this.$store.dispatch('directtalk/sendSeekerContact', contact)
      const updateSeekerInfo = {
        name: contact.name,
        email: contact.user_email,
        tel: contact.user_tel,
        sessionid: this.seeker.id,
        group: this.data.ckey,
      }
      this.$store.dispatch('directtalk/updateSeekerData', updateSeekerInfo)
    },
    sendSeekerContactValidation (contact) {
      // 未入力チェック
      let emptyList = []
      for (const c in contact) {
        if (contact[c] === '') {
          emptyList.push(c)
        }
      }
      let alertContent = ''
      const emptyAnounse = () => {
        if (alertContent === '') alertContent += '■以下の項目が未入力です\n'
      }
      for (const item of emptyList) {
        switch (item) {
          case 'name':
            emptyAnounse()
            alertContent += ('・お名前\n')
            break
          case 'user_email':
            emptyAnounse()
            alertContent += ('・Email\n')
            break
          case 'user_tel':
            emptyAnounse()
            alertContent += ('・TEL\n')
            break
          case 'content':
            emptyAnounse()
            alertContent += ('・内容\n')
            break
        }
      }
      // メールアドレスの形式チェック
      const emailPatterm = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/
      if (contact.user_email !== '' && !emailPatterm.test(contact.user_email)) {
        if (alertContent === '') alertContent += '■Emailの形式が不正です'
        else alertContent += '\n■Emailの形式が不正です'
      }
      // 電話番号の形式チェック
      const telPattern = /^\d*$/
      if (contact.user_tel !== '' && !telPattern.test(contact.user_tel)) {
        if (alertContent === '') alertContent += '■TELの形式が不正です 数値のみハイフンなしでの入力をお願い致します'
        else alertContent += '\n■TELの形式が不正です 数値のみハイフンなしでの入力をお願い致します'
      }
      // アラートの表示
      if (alertContent !== '') {
        alert(alertContent)
        return true
      }
    },
    setLocalStorage (value) {
      localStorage.setItem('scenariolv_' + (this.minipk || this.targetID), value)
    },
    cancelModal () {
      this.isShowModal = false
    }
  }
}
</script>
<style lang="scss" scoped>
.chat-box {
  display: flex;
  flex-direction: column;
  height: calc(100% - 50px);
  background: rgba(255, 255, 255, 0.1);
  position: relative;
}

.balloon-msg {
  border-radius: 10px;
  width: 100%;
  padding: 7px;
  background: aliceblue;
  position: relative;
  font-size: 12px;
  text-align: left;
}
.balloon-msg:before {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -25px;
  border: 25px solid transparent;
  border-top: 20px solid aliceblue;
}
.new-msg-notify {
  position: absolute;
  top: 55px;
  left: 0;
  margin: 2.5%;
  width: 95%;
  height: 30px;
  font-size: 12px;
  border-radius: 15px;
  background: #29B2EE;
  color: white;
  white-space: normal;
  font-weight: 600;
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
}
.close-button {
  position: absolute;
  right: 3%;
  font-size: 15px;
  font-weight: 600;
  background: transparent;
  border: none;
  color: white;
}
.line-red {
  border-top: solid thin red;
}
.chat-box-timeline {
  height: calc(100% - 54px);
  width: 100%;
}
.parent-form {
  width: 100%;
  height: 70px;
  border-top: solid thin #CCC;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.no-input-form {
  height: 25px !important;
  border-top: solid thin transparent;
}
.child-form {
  text-align: center;
  padding-bottom: 0px !important;
  min-height: 45px;
}
.input-button {
  background: transparent;
  border: none;
  resize: none;
  outline:none;
  font-size: 20px;
  margin-left: -10px;
  padding-right: 14px;
}

textarea {
  min-width: calc(100vw - 96px);
  max-width: calc(100vw - 96px);
  font-size: 18px;
  border: none;
  resize: none;
  outline:none;
  line-height: 25px;
  padding-top: 10px;
  padding-left: 8px;
}

.chat-list-box {
  height: calc(100% - 25px);
  width: 100%;
}
.chat-list-box > .bln-lst {
  padding-top: 8px;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: none;
}
.bln-lst::-webkit-scrollbar {
  width:  5px;
  height: 5px;
  visibility: hidden;
}
.chat-list-box > .tap-box {
  color: #333;
  position: absolute;
  bottom: 24px;
  left: 0;
  right: 0;
  margin: auto;
  height: 160px;
  width: 100%;
  .tap {
    display: flex;
    justify-content: center;
    align-items: center;
    p {
      width: 216px
    }
  }
}
.bln-leave-active,
.bln-enter-active {
  transition: .5s ease;
  transform-origin: top;
}
.bln-leave-to,
.bln-enter {
  opacity: 0;
}
.bln-leave,
.bln-enter-to {
  opacity: 1;
}
.bln-move {
  transition: .5s;
  transform-origin: top;
}
.btn-menu {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  background: rgba(255, 255, 255, 0);
}
.huyuu {
  animation: huwahuwa 2s ease-out;
  animation-iteration-count: infinite;
}
@keyframes huwahuwa {
  0% {
    transform: translateY(0px) scale(0.8);
  }
  50% {
    transform: translateY(-7.5px) scale(0.8);
  }
  100% {
    transform: translateY(0px) scale(0.8);
  }
}
.footer-area {
  display: flex;
  justify-content: space-between;
}
.right-block {
  width: 150px;
  button {
    font-size: 10px;
  }
}
.center-block {
  display: flex;
  justify-content: center;
  align-items: center;
}
.auto-button {
  border-radius: 16px;
}

</style>



// WEBPACK FOOTER //
// src/views/ChatWidget/ChatDialog.vue